var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXLogoWide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 678,
    height: 95.618,
    viewBox: "0 0 678 95.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_761",
    "data-name": "Rectangle 761",
    width: 95.618,
    height: 95.618,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(-455.5 -852.878)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 266,
    transform: "translate(455.5 901.5)",
    fill: "none",
    stroke: "#113657",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 255,
    transform: "translate(878.5 901.5)",
    fill: "none",
    stroke: "#113657",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(752.191 852.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M130.628,137.827h-1.69v-.868h4.325v.868h-1.69v4.461h-.944Z",
    transform: "translate(-47.088 -50.018)",
    fill: "#214669"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M137.314,136.96h1l1.621,2.52,1.622-2.52h1v5.33h-.936v-3.822l-1.683,2.513h-.03l-1.668-2.5v3.808h-.921Z",
    transform: "translate(-50.147 -50.018)",
    fill: "#214669"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M78.581,57.47l31.666,31.666a.938.938,0,0,0,.622.251.823.823,0,0,0,.594-.263,47.8,47.8,0,0,0,.252-64.754.82.82,0,0,0-.594-.268h-.02a.85.85,0,0,0-.606.251L78.581,56.267a.853.853,0,0,0,0,1.2",
    transform: "translate(-28.608 -8.802)",
    fill: "#214669"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M89.342,13.109a47.8,47.8,0,0,0-65.4-.347.823.823,0,0,0-.263.593.855.855,0,0,0,.251.623L56.21,46.255a.871.871,0,0,0,1.2,0L89.349,14.319A.848.848,0,0,0,89.6,13.7a.822.822,0,0,0-.257-.592",
    transform: "translate(-8.648)",
    fill: "#a44148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M24.353,110.439a.853.853,0,0,0-.251.626.823.823,0,0,0,.269.595,47.8,47.8,0,0,0,64.854-.347.82.82,0,0,0,.262-.594.847.847,0,0,0-.251-.621L57.566,78.429a.852.852,0,0,0-1.2,0Z",
    transform: "translate(-8.802 -28.552)",
    fill: "#a44148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M12.856,23.786a47.8,47.8,0,0,0,.253,65.5.847.847,0,0,0,1.211.005L46.352,57.259a.851.851,0,0,0,0-1.2L14.071,23.775a.854.854,0,0,0-.607-.251h-.015a.823.823,0,0,0-.593.262",
    transform: "translate(0 -8.591)",
    fill: "#214669"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M118.87,78.452a11.606,11.606,0,0,1-5.54-1.642,3.436,3.436,0,0,0-1.025,1.47h-.854V70.929h.991c.308,1.949,2.017,5.642,6.189,5.642,2.29,0,3.692-1.265,3.692-3.145,0-1.539-1.777-2.462-3.795-3.557l-3.317-1.812a6.3,6.3,0,0,1-3.488-5.744c0-2.941,2.462-5.539,6.086-5.539a7.058,7.058,0,0,1,4.343,1.4,3.414,3.414,0,0,0,1.025-1.4h.787v6.564h-.957c-.581-2.633-2.087-4.718-5.026-4.718a2.6,2.6,0,0,0-2.873,2.53c0,1.675,1.471,2.394,3.59,3.522l2.838,1.5c2.975,1.573,4.1,3.59,4.1,5.744a6.443,6.443,0,0,1-6.77,6.531",
    transform: "translate(-40.702 -20.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M31.382,75.086v2.462c-3.556,0-4.479,1.778-7.83,1.778-6.018,0-9.643-4.89-9.643-10.84s3.864-10.839,9.471-10.839a7.214,7.214,0,0,1,5.744,2.462,2.837,2.837,0,0,0,.923-1.744H30.9v7.522h-.923C29.058,61.443,26.767,59.6,24.1,59.6c-4.478,0-5.744,4.65-5.744,8.889,0,4.206.991,8.993,5.5,8.993,2.565,0,3.933-1.675,3.933-4.138,0-1.47-.616-2.222-2.633-2.222v-.992h8.514v.992c-1.949,0-2.291.547-2.291,3.966",
    transform: "translate(-5.08 -21.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M55.357,27.722H52.539V26.077h7.633v1.644H57.365v7.632H55.357Z",
    transform: "translate(-19.188 -9.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M68.641,26.078h2.005V29.7h3.733V26.078h2.005v9.276H74.379V31.34H70.646v4.014H68.641Z",
    transform: "translate(-25.068 -9.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M92.847,31.353H88.411v2.356h4.894l-.238,1.644h-6.6V26.077h6.578v1.644H88.411v1.988h4.436Z",
    transform: "translate(-31.577 -9.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M65.963,119.273c-.478,2.215-2.148,3.828-5.121,3.828-3.765,0-5.545-2.664-5.545-6.042,0-3.255,1.836-6.172,5.668-6.172,3.161,0,4.694,1.856,4.984,3.841H63.382a2.329,2.329,0,0,0-2.5-1.827c-2.117,0-2.935,1.9-2.935,4.065,0,2.007.709,4.122,3,4.122a2.362,2.362,0,0,0,2.429-1.814Z",
    transform: "translate(-20.195 -40.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M87.919,116.956c0,3.3-1.984,6.149-5.84,6.149C78.353,123.1,76.4,120.4,76.4,117c0-3.455,2.155-6.109,5.842-6.109,3.474,0,5.675,2.434,5.675,6.069m-8.866-.011c0,2.318,1.018,4.072,3.122,4.072,2.284,0,3.092-1.913,3.092-4.028,0-2.246-.92-4.011-3.133-4.011-2.145,0-3.081,1.656-3.081,3.968",
    transform: "translate(-27.902 -40.496)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogoWide);
export default __webpack_public_path__ + "static/media/x_logo_wide.b0d5d2d9be73e17e0b595b67e6565d9e.svg";
export { ForwardRef as ReactComponent };